/** Invite preview / accept + post-MFA finalize. */
import { apiGet, apiPost } from './client';
import type { LoginResponse200, UserSummary } from './auth';

export interface InvitePreview {
  email: string;
  first_name: string;
  last_name: string;
  expires_ts: string;
}

export async function previewInvite(code: string): Promise<InvitePreview> {
  return apiGet(`/auth/invite/preview/?code=${encodeURIComponent(code)}`);
}

export interface AcceptInviteResponse {
  enrollment_token: string;
  enrollment_token_expires_in: number;
  user: UserSummary;
  must_enroll_mfa: boolean;
}

export async function acceptInvite(code: string, password: string): Promise<AcceptInviteResponse> {
  return apiPost('/auth/invite/accept/', { code, password });
}

export async function finalize(enrollmentToken: string): Promise<LoginResponse200> {
  return apiPost('/auth/finalize/', undefined, {
    headers: { 'X-Enrollment-Token': enrollmentToken },
  });
}
